import { useEffect, useRef, useState } from 'react';
import { Coins, Sparkles } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle, DialogDescription } from './ui/dialog';
import { subscribeAiConsent } from '../lib/aiConsent';
import { useI18n } from '../i18n';

export default function AiCostDialog() {
    const [decision, setDecision] = useState(null);
    const cancelRef = useRef(null);
    const { locale } = useI18n();
    const da = locale === 'da';
    useEffect(() => subscribeAiConsent(setDecision), []);
    useEffect(() => {
        if (!decision) return undefined;
        const remaining = Date.parse(decision.quote.expires_at) - Date.now();
        const timer = setTimeout(() => decision.finish(false), Math.max(0, Number.isFinite(remaining) ? remaining : 0));
        return () => clearTimeout(timer);
    }, [decision]);
    const q = decision?.quote;
    return <Dialog open={!!decision} onOpenChange={open => { if (!open) decision?.finish(false); }}>
        <DialogContent overlayClassName="!z-[240]" className="!z-[250] !w-[calc(100%_-_2rem)] !max-w-md !rounded-3xl !border-brand-ochre/40 !bg-brand-bg !text-brand-ink max-h-[80dvh] overflow-y-auto"
            onOpenAutoFocus={e => { e.preventDefault(); cancelRef.current?.focus(); }}>
            <DialogTitle className="flex items-center gap-2 font-serif !text-2xl"><Sparkles className="text-brand-ochre" />{da ? 'Klar til AI?' : 'Ready for AI?'}</DialogTitle>
            <DialogDescription className="!text-brand-ink2">{da ? 'Du godkender kun denne forespørgsel — ikke fremtidige køb.' : 'Approve this request only — not future purchases.'}</DialogDescription>
            {q && <>
                <div className="rounded-2xl bg-brand-ochre/10 p-4 space-y-2" aria-label={da ? 'Prisoversigt' : 'Price breakdown'}>
                    <p>{da ? 'Svar/analyser' : 'Answers/analyses'} <strong className="float-right">{q.count}</strong></p>
                    <p>{da ? 'Fra Premium-puljen' : 'From Premium allowance'} <strong className="float-right">{q.included}</strong></p>
                    <p className="flex items-center gap-2"><Coins size={18} />GrowGold <strong className="ml-auto">{q.growgold}</strong></p>
                    <p className="border-t border-brand-ochre/20 pt-2">{da ? 'GrowGold bagefter' : 'GrowGold afterwards'} <strong className="float-right">{q.balance - q.growgold}</strong></p>
                </div>
                <p className="text-sm text-brand-ink2">{da ? 'Fejlede analyser refunderes. Premium-enheder returneres til deres oprindelige periode. Afbrydes forbindelsen, finder du status og svar under Premium → AI-historik.' : 'Failed analyses are refunded. Included units return to their original period. If disconnected, find the status and answer under Premium → AI history.'}</p>
                <div className="flex flex-wrap gap-3">
                    <button ref={cancelRef} onClick={() => decision.finish(false)} className="flex-1 min-h-12 rounded-full border border-brand-ink2/30 px-4">{da ? 'Ikke nu' : 'Not now'}</button>
                    <button onClick={() => decision.finish(true)} className="flex-1 min-h-12 rounded-full bg-brand-green text-white px-4">{da ? 'Godkend' : 'Approve'} · {q.growgold} GG</button>
                </div>
            </>}
        </DialogContent>
    </Dialog>;
}
